export const checkCompanyAccounts = ({ validationResult }) => ({
  valid: validationResult.valid.slice(),
  invalid: validationResult.invalid.slice(),
});
